// libraries
import { recursiveBracket } from "@cloudspire/legacy-shared/src/libraries";

/**
 * Formatte les erreurs API pour quelles soient normalisées.
 */
const errorAlfredFormatErrors = ({ errorList, path = [] }) => {
  let output = {};

  for (const [errorName, error] of Object.entries(errorList)) {
    if (Array.isArray(error) && "string" === typeof error[0]) {
      // On arrive à la profondeur finale
      output[recursiveBracket([...path, errorName])] = error;
    } else if ("object" === typeof error) {
      output = {
        ...output,
        ...errorAlfredFormatErrors({
          errorList: error,
          path: [...path, errorName],
        }),
      };
    }
  }

  return output;
};

export default errorAlfredFormatErrors;
